import {connect, Dispatch} from '@modifi/redux'
import {aShowDialog, DialogManager} from '@modifi/plugin-dialogs'

import DeleteLegalRepresentativeButton from './DeleteLegalRepresentativeButton'
import {aDelete} from './store'
import DeleteLegalRepDialog, {DELETE_LEGAL_REP_DIALOG_NAME} from './dialogs'

const mapStateToProps = null

DialogManager.addDialog(DELETE_LEGAL_REP_DIALOG_NAME, DeleteLegalRepDialog)

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: {externalPersonId: string; target: string}
): {onClick: () => void} => ({
  onClick: (): void => {
    const onConfirm = async (): Promise<void> => {
      await dispatch(aDelete(ownProps.externalPersonId) as any)
    }

    dispatch(
      aShowDialog(DELETE_LEGAL_REP_DIALOG_NAME, {
        onConfirm,
        target: ownProps.target,
        entryType: 'confirm-delete-person',
      })
    )
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteLegalRepresentativeButton)
